import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cc159c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-2 d-flex justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createTextVNode("Job"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Buddy"),
    /*#__PURE__*/_createTextVNode(" Smart Search")
  ]),
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-stars text-primary" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-2 d-flex justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("p", null, "The smart way to find your dream job")
], -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-11\" data-v-7cc159c9><div class=\"form\" data-v-7cc159c9><input type=\"text\" class=\"form-control form-input\" placeholder=\"Find your dream job...\" data-v-7cc159c9><span class=\"left-pan\" data-v-7cc159c9><i class=\"bi bi-search\" data-v-7cc159c9></i></span></div></div>", 1)
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-funnel" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "m-1 rounded-3 border"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row d-flex justify-content-center align-items-center p-1" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "form" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control form-input",
          placeholder: "Location"
        }),
        /*#__PURE__*/_createElementVNode("span", { class: "left-pan" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pin" })
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "form" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control form-input",
          placeholder: "Salary"
        }),
        /*#__PURE__*/_createElementVNode("span", { class: "left-pan" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cash-stack" })
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "form" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control form-input",
          placeholder: "Posted On"
        }),
        /*#__PURE__*/_createElementVNode("span", { class: "left-pan" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar" })
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "form" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control form-input",
          placeholder: "Remote"
        }),
        /*#__PURE__*/_createElementVNode("span", { class: "left-pan" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "bi bi-laptop" })
        ])
      ])
    ])
  ])
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "pt-5 p-2 d-flex justify-content-center align-items-center" }
const _hoisted_11 = {
  key: 0,
  class: "row table-responsive px-2"
}
const _hoisted_12 = { class: "col col-md-12 border rounded-3" }
const _hoisted_13 = { class: "table table-hover" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Title"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Company"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Location"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Salary"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Posted On"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Match"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" })
  ])
], -1))
const _hoisted_15 = { class: "d-flex justify-content-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "text-center"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No jobs found.", -1))
const _hoisted_19 = [
  _hoisted_18
]

import { ref, onMounted } from "vue";
import Gauge from "@/components/Gauge.vue";
import { JobSearchService } from "@/services/JobSearchService";
import jobsData from "@/data/jobs";
import JobDetailsModal from "../components/JobDetailsModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'JobSearchView',
  setup(__props) {

const jobs = ref([]);
const selectedJob = ref(null);
const filterExpanded = ref(false);
onMounted(() => {
  loadUserJobs();
});

async function loadUserJobs() {
  jobs.value = jobsData.data.jobsForUser.jobs;
  // const response = await JobSearchService.getJobsForUser();
  // jobs.value = JSON.parse(response.data.jobsForUser.jobsForUser.jobs);
}

function toggleFilter() {
  filterExpanded.value = !filterExpanded.value;
}

function formatDate(timestamp: number) {
  const date = new Date(timestamp);
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

function viewJobDetails(job: any) {
  selectedJob.value = job;
}

function openUrl(url: string) {
  window.open(url, "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(JobDetailsModal, {
      job: selectedJob.value,
      onOpen: openUrl,
      ref: "jobDetailsModal"
    }, null, 8, ["job"]),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", { class: "row d-flex justify-content-center align-items-center p-1" }, [
      _hoisted_4,
      _createElementVNode("div", { class: "col-md-1" }, [
        _createElementVNode("div", {
          onClick: toggleFilter,
          class: "btn btn-outline-primary btn-filter"
        }, _hoisted_6)
      ])
    ]),
    _createVNode(_Transition, { name: "expand" }, {
      default: _withCtx(() => [
        (filterExpanded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_10, [
      (jobs.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("table", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobs.value, (job) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: job.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(job.title), 1),
                      _createElementVNode("td", null, _toDisplayString(job.company), 1),
                      _createElementVNode("td", null, _toDisplayString(job.location), 1),
                      _createElementVNode("td", null, "£" + _toDisplayString(job.min_amount) + " - £" + _toDisplayString(job.max_amount) + " P/A", 1),
                      _createElementVNode("td", null, _toDisplayString(formatDate(job.date_posted)), 1),
                      _createElementVNode("td", _hoisted_15, [
                        _createVNode(Gauge, {
                          class: "gauge",
                          value: job.match
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary btn-sm",
                          onClick: ($event: any) => (viewJobDetails(job))
                        }, " View ", 8, _hoisted_16)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
    ])
  ]))
}
}

})